const HEIZA_CUFFLINKS_URL = '/collections/cufflinks';

function heizaFixCufflinksLinks(root = document) {
  root.querySelectorAll('a[href], [data-href]').forEach((element) => {
    const text = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!text.includes('cufflinks')) return;

    if (element.hasAttribute('href')) {
      const href = element.getAttribute('href');
      if (!href || href === '/') {
        element.setAttribute('href', HEIZA_CUFFLINKS_URL);
      }
    }

    if (element.hasAttribute('data-href')) {
      const dataHref = element.getAttribute('data-href');
      if (!dataHref || dataHref === '/') {
        element.setAttribute('data-href', HEIZA_CUFFLINKS_URL);
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => heizaFixCufflinksLinks(), { once: true });
} else {
  heizaFixCufflinksLinks();
}

new MutationObserver(() => heizaFixCufflinksLinks()).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
